import React from 'react';
import { cx } from '../cx';

// D-09 §15.3 — Card (.app-card > .thumb? + .body)
export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  thumb?: React.ReactNode;
}

export function Card({ thumb, className = '', children, ...props }: CardProps) {
  // role(예: clickable 카드의 role="button")이 붙으면 <article> 에는 허용되지 않으므로(ARIA aria-allowed-role) <div> 로 렌더한다.
  const Tag = props.role ? 'div' : 'article';
  return (
    <Tag className={cx('app-card', className)} {...props}>
      {thumb != null && <div className="thumb">{thumb}</div>}
      <div className="body">{children}</div>
    </Tag>
  );
}
